<!-- 联盟成员列表 -->
<template>
    <div id="goodSearch" class="business-content-main" v-loading="loading">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-s-ticket" type="warning" class="search-btn" v-if="permission.invite" @click="dialogInviteVisible = true">成员邀请</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">企业名称</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.EntpName" placeholder="请输入企业名称"></el-input>
                <div class="search-name">联盟角色</div>
                <el-select
                    class="search-item"
                    size="small"
                    v-model="searchData.RoleId"
                    remote
                    filterable
                    allow-create
                    placeholder="请输入角色名称"
                    :remote-method="querySearch"
                    v-select-scroll-more="searchRoleLoad"
                >
                    <el-option v-for="item in roleOptions" :key="item.RoleId" :label="item.RoleName" :value="item.RoleId"> </el-option>
                </el-select>
                <div class="search-name">加入时间</div>
                <el-date-picker
                    v-model="dateTimes"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    @change="handleChange"
                    size="small"
                    class="search-name"
                ></el-date-picker>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <template v-if="noData">
            <div class="no-data">暂无数据</div>
        </template>
        <template v-else>
            <div class="table-ctn">
                <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%">
                    <el-table-column width="200px" prop="EntpName" label="联盟成员" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-link @click="showEntpInfoes(scope.row.EntpId)" type="primary" :underline="false">{{ scope.row.EntpName }}</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column width="160px" prop="RoleName" label="联盟角色" show-overflow-tooltip></el-table-column>
                    <el-table-column width="140px" prop="PriceLevelName" label="价格段位" show-overflow-tooltip></el-table-column>
                    <el-table-column width="140px" prop="Contact" label="联系人" show-overflow-tooltip></el-table-column>
                    <el-table-column width="140px" prop="PhoneNum" label="联系电话" show-overflow-tooltip></el-table-column>
                    <el-table-column width="160px" prop="JoinTime" label="加入时间" show-overflow-tooltip></el-table-column>
                    <el-table-column width="100" prop="IsAdmin" label="是否管理员" show-overflow-tooltip
                        ><template slot-scope="scope">{{ scope.row.IsAdmin ? '是' : '否' }}</template></el-table-column
                    >
                    <el-table-column width="110" prop="IsRele" label="是否已有关联" show-overflow-tooltip
                        ><template slot-scope="scope">{{ scope.row.IsRele ? '是' : scope.row.IsNoNeedRele ? '无需关联' : '否' }}</template></el-table-column
                    >
                    <el-table-column width="200px" prop="CusName" label="关联客户" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div style="color: #409eff" @click="showCusDialog(scope.row.CusId)" type="text">
                                {{ scope.row.CusName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="160px" prop="ReleTime" label="关联时间" show-overflow-tooltip></el-table-column>
                    <el-table-column fixed="right" label="操作" :autoWidth="true">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button type="text" size="mini" @click="priceLevelEdit(scope.row)" v-if="permission.setPriceLevel && !scope.row.IsAdmin">{{
                                    permission.setPriceLevel
                                }}</el-button>
                                <el-button type="text" size="mini" @click="memberAuthEdit(scope.row)" v-if="!scope.row.IsNoNeedRele && permission.permissionSet">{{
                                    permission.permissionSet
                                }}</el-button>
                                <el-button type="text" size="mini" @click="tranEntps(scope.row.EntpId)" v-if="!scope.row.IsRele && !scope.row.IsNoNeedRele && permission.releCus"
                                    >提取档案</el-button
                                >
                                <el-button type="text" size="mini" @click="releEntps(scope.row.EntpId)" v-if="!scope.row.IsRele && !scope.row.IsNoNeedRele && permission.releCus">{{
                                    permission.releCus
                                }}</el-button>
                                <el-button
                                    type="text"
                                    size="mini"
                                    style="color: orange"
                                    @click="reReleEntps(scope.row.EntpId)"
                                    v-if="scope.row.IsRele && !scope.row.IsNoNeedRele && permission.releCus"
                                    >重新关联</el-button
                                >
                                <!-- <el-button
                  type="text"
                  size="mini"
                  @click="releEntps(scope.row)"
                  style="color: orange"
                  >{{ permission.forbidden }}</el-button
                > -->
                                <el-button
                                    type="text"
                                    size="mini"
                                    style="color: red"
                                    @click="kickOut(scope.row)"
                                    v-if="!scope.row.IsNoNeedRele && permission.kickOut && !scope.row.IsAdmin"
                                    >{{ permission.kickOut }}</el-button
                                >
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
        </template>
        <el-dialog :close-on-click-modal="false" title="成员企业信息" :visible.sync="dialogEntpVisible" width="1000px">
            <div class="dialog-content" v-if="dialogEntpVisible">
                <EntpDatas ref="customerEdit" :entpId="entpId" @closeDialog="closeEntpDialog"></EntpDatas>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="邀请成员" :visible.sync="dialogInviteVisible" width="1000px">
            <div v-if="dialogInviteVisible">
                <InviteEntp @closeDialog="closeInviteDialog"></InviteEntp>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="客户信息" :visible.sync="dialogCusVisible" width="1000px">
            <div class="dialog-content" v-if="dialogCusVisible">
                <CustomerEdit ref="customerEdit" :cusId="entpCusId" :type="3" @closeDialog="closeCusDialog" source="1"></CustomerEdit>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="客户信息" :visible.sync="dialogVisible" width="1000px">
            <div class="dialog-content" v-if="dialogVisible">
                <EntityEdit :releEntpId="releEntpId" :type="1" @closeDialog="closeEntityDialog" :source="1"></EntityEdit>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="关联客户信息" :visible.sync="dialogReleVisible" width="1000px">
            <div v-if="dialogReleVisible">
                <ReleEntpEntity :releEntpId="releEntpId" :source="1" @closeDialog="closeReleDialog"></ReleEntpEntity>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :title="authTitle" :visible.sync="dialogAuthVisible" width="1000px">
            <div class="dialog-content" v-if="dialogAuthVisible">
                <UnionMemberAuthEdit ref="memberAuthEdit" :memberId="memberId" :mRoleId="roleId" @closeDialog="closeAuthDialog"></UnionMemberAuthEdit>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="分配价格段位" :visible.sync="dialogLevelVisible" width="600px">
            <div class="dialog-content" v-if="dialogLevelVisible">
                <UnionPriceLevelSelected ref="levelEdit" :memberId="memberId" :priceLevelId="priceLevelId" @closeDialog="closeLevelDialog"></UnionPriceLevelSelected>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import EntpDatas from '@/components/entpUnion/entityManage/entpDatas';
import InviteEntp from '@/components/entpUnion/entityManage/inviteEntp';
import CustomerEdit from '@/components/business/customerManage/customerEdit';
import EntityEdit from '@/components/entpUnion/entityManage/entityEdit';
import ReleEntpEntity from '@/components/entpUnion/entityManage/releEntpEntity';
import UnionMemberAuthEdit from '@/components/entpUnion/entityManage/unionMemberAuthEdit';
import UnionPriceLevelSelected from '@/components/entpUnion/entityManage/unionPriceLevelSelected';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'labels',
    components: {
        elTableColumn,
        breadcrumb,
        EntpDatas,
        InviteEntp,
        CustomerEdit,
        EntityEdit,
        ReleEntpEntity,
        UnionMemberAuthEdit,
        UnionPriceLevelSelected
    },
    data() {
        return {
            searchData: {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                EntpName: '',
                RoleId: '',
                State: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            },
            loading: false,
            dateTimes: '',
            noData: false,
            entpId: '',
            memberId: '',
            priceLevelId: '',
            roleId: '',
            entpCusId: '',
            authTitle: '',
            dialogEntpVisible: false,
            dialogInviteVisible: false,
            dialogCusVisible: false,
            dialogReleVisible: false,
            dialogVisible: false,
            dialogAuthVisible: false,
            dialogLevelVisible: false,
            releEntpId: '',
            tableData: [],
            tableDataLength: 0,
            permission: {},
            roleForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            roleOptions: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getTableData();
        this.permission = this.$util.getUnionPermission('MemberManage');
        this.querySearch();
    },
    methods: {
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        // 重置表单
        resetSearch() {
            this.searchData = {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                EntpName: '',
                RoleId: '',
                State: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            };
            this.dateTimes = '';
            this.querySearch('');
        },
        // 获取数据
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpUnions/GetUnionMemberList',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        this.noData = true;
                        return;
                    }
                    this.noData = false;
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        showEntpInfoes(entpId) {
            if (entpId) {
                this.dialogEntpVisible = true;
                this.entpId = entpId;
            }
        },
        closeEntpDialog() {
            this.dialogEntpVisible = false;
        },
        closeInviteDialog() {
            this.dialogInviteVisible = false;
        },
        showCusDialog(cusId) {
            if (cusId) {
                this.entpCusId = cusId;
                this.dialogCusVisible = true;
            }
        },
        closeCusDialog() {
            this.dialogCusVisible = false;
        },
        closeEntityDialog(isEdit) {
            this.dialogVisible = false;
            if (isEdit) this.getTableData();
        },
        tranEntps(entpId) {
            if (entpId) {
                this.releEntpId = entpId;
                this.dialogVisible = true;
            }
        },
        releEntps(entpId) {
            if (entpId) {
                this.releEntpId = entpId;
                this.dialogReleVisible = true;
            }
        },
        reReleEntps(entpId) {
            if (entpId) {
                this.$confirm('您确定要重新进行企业信息的关联吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '不了',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.releEntpId = entpId;
                        this.dialogReleVisible = true;
                    })
                    .catch(() => {});
            }
        },
        closeReleDialog(isEdit) {
            this.dialogReleVisible = false;
            if (isEdit) this.getTableData();
        },
        kickOut(item) {
            let that = this;
            if (item.EntpId) {
                that.$confirm('您确定要将【' + item.EntpName + '】踢出联盟吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '不了',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.loading = true;
                        that.$util
                            .axiosPost({
                                url: '/api/EntpUnions/KickOutUnionMembers',
                                data: {
                                    UnionId: that.searchData.UnionId,
                                    MemberId: item.EntpId
                                },
                                hideLoading: true
                            })
                            .then(res => {
                                that.$util.successMsg('成功踢出联盟');
                                that.getTableData();
                            })
                            .finally(() => {
                                that.loading = false;
                            });
                    })
                    .catch(() => {});
            }
        },
        memberAuthEdit(item) {
            if (item) {
                this.memberId = item.MemberId;
                this.roleId = item.RoleId;
                this.authTitle = '为联盟成员【' + item.EntpName + '】分配权限';
            }
            this.dialogAuthVisible = true;
        },
        closeAuthDialog() {
            this.dialogAuthVisible = false;
        },
        // 获取角色列表
        querySearch(key) {
            if (![undefined].includes(key)) {
                this.roleForm.Page = 1;
                this.roleForm.stopLoad = false;
                this.roleForm.key = key;
                this.roleOptions = [];
            }
            if (this.roleForm.stopLoad) return;
            this.$util.getUnionRoleList(this.roleForm.key, this.roleForm.Page, this.roleForm.Limit).then(data => {
                if (!data) return;
                this.roleForm.stopLoad = data.length < this.roleForm.Limit;
                this.roleOptions = this.$util.uniqueArr(this.roleOptions, data);
            });
        },
        searchRoleLoad() {
            this.roleForm.Page += 1;
            this.querySearch();
        },
        priceLevelEdit(item) {
            if (item) {
                this.memberId = item.MemberId;
                this.priceLevelId = item.PriceLevelId;
                this.dialogLevelVisible = true;
            }
        },
        closeLevelDialog(isEdit) {
            if (isEdit) this.getTableData();
            this.dialogLevelVisible = false;
        }
    }
};
</script>
